(() => {
  'use strict';

  const INSTANCE_KEY = '__granviaInfiniteScroll';

  class InfiniteCollectionScroll {
    constructor() {
      this.grid = document.querySelector('products-grid[data-next-url]');

      if (!this.grid) {
        return;
      }

      // Evita crear múltiples instancias sobre el mismo grid
      if (this.grid[INSTANCE_KEY]) {
        return;
      }

      this.grid[INSTANCE_KEY] = this;

      this.productGrid = this.grid.querySelector('#product-grid');
      this.sentinel = this.grid.querySelector('.infinite-scroll-sentinel');
      this.loading = this.grid.querySelector('.infinite-scroll-loading');
      this.pagination = this.grid.querySelector('.collection-pagination');

      if (!this.productGrid || !this.sentinel) {
        return;
      }

      this.currentPage = parseInt(
        this.grid.dataset.currentPage || '1',
        10
      );

      this.totalPages = parseInt(
        this.grid.dataset.totalPages || '1',
        10
      );

      this.nextUrl = this.grid.dataset.nextUrl || null;

      this.isLoading = false;

      this.init();
    }

    init() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            !this.isLoading
          ) {
            this.loadNextPage();
          }
        },
        {
          rootMargin: '800px 0px'
        }
      );

      this.observer.observe(this.sentinel);

      if (this.pagination) {
        this.pagination.style.display = 'none';
      }
    }

    async loadNextPage() {
      if (
        this.isLoading ||
        !this.nextUrl ||
        this.currentPage >= this.totalPages
      ) {
        return;
      }

      this.isLoading = true;

      this.showLoading();

      // Guardamos la URL actual antes del request
      const requestedUrl = this.nextUrl;

      try {
        const response = await fetch(requestedUrl, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(
            `Infinite scroll request failed: ${response.status}`
          );
        }

        const html = await response.text();

        const parser = new DOMParser();

        const documentHTML = parser.parseFromString(
          html,
          'text/html'
        );

        const nextGrid = documentHTML.querySelector(
          '#product-grid'
        );

        if (!nextGrid) {
          throw new Error(
            'No se encontró #product-grid en la siguiente página.'
          );
        }

        /*
         * Obtenemos únicamente los elementos
         * de la siguiente página.
         */
        const products = Array.from(
            nextGrid.children
        ).filter((element) => {
            return !element.classList.contains('pgb');
        });

        /*
         * Evitamos agregar elementos duplicados
         * si Shopify devuelve nuevamente contenido.
         */
        const existingProductIds = new Set(
          Array.from(
            this.productGrid.querySelectorAll(
              '[data-product-id]'
            )
          )
            .map((element) =>
              element.dataset.productId
            )
            .filter(Boolean)
        );

        products.forEach((element) => {
          const productId =
            element.dataset.productId;

          if (
            productId &&
            existingProductIds.has(productId)
          ) {
            return;
          }

          this.productGrid.appendChild(
            element.cloneNode(true)
          );

          if (productId) {
            existingProductIds.add(productId);
          }
        });

        /*
         * Buscamos la URL de la página siguiente.
         */
        const nextProductsGrid =
          documentHTML.querySelector(
            'products-grid'
          );

        if (nextProductsGrid) {
          this.nextUrl =
            nextProductsGrid.dataset.nextUrl || null;

          this.currentPage =
            parseInt(
              nextProductsGrid.dataset.currentPage ||
                this.currentPage + 1,
              10
            );
        } else {
          this.nextUrl = null;
          this.currentPage++;
        }

        /*
         * Actualizamos los atributos del grid actual.
         */
        this.grid.dataset.currentPage =
          this.currentPage;

        if (this.nextUrl) {
          this.grid.dataset.nextUrl =
            this.nextUrl;
        } else {
          delete this.grid.dataset.nextUrl;
        }

        /*
         * IMPORTANTE:
         *
         * Ya NO disparamos product_grid:update aquí.
         *
         * Ese evento provocaba que se crearan
         * nuevos observers y termináramos
         * cargando la misma página varias veces.
         */

        /*
         * Cuando llegamos a la última página,
         * detenemos el observer.
         */
        if (
          !this.nextUrl ||
          this.currentPage >= this.totalPages
        ) {
          this.observer.disconnect();
        }

      } catch (error) {
        console.error(
          'Gran Vía Infinite Scroll:',
          error
        );

        /*
         * Si falla el request, conservamos
         * la URL para poder intentarlo nuevamente.
         */
        this.nextUrl = requestedUrl;

      } finally {
        this.isLoading = false;
        this.hideLoading();
      }
    }

    showLoading() {
      if (this.loading) {
        this.loading.hidden = false;
      }
    }

    hideLoading() {
      if (this.loading) {
        this.loading.hidden = true;
      }
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
      }

      delete this.grid[INSTANCE_KEY];
    }
  }

  /*
   * Inicialización
   */
  function initInfiniteScroll() {
    new InfiniteCollectionScroll();
  }

  document.addEventListener(
    'DOMContentLoaded',
    initInfiniteScroll
  );

  /*
   * Cuando los filtros de Shopify reemplazan
   * ProductGridContainer, necesitamos crear
   * una nueva instancia.
   *
   * Pero SOLO si realmente existe un nuevo
   * products-grid.
   */
  window.addEventListener(
    'product_grid:update',
    () => {
      setTimeout(() => {
        initInfiniteScroll();
      }, 150);
    }
  );

})();